import DataConfig from "./DataConfig";

export default class DataService {
	static getCivilStatus() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = DataConfig.endpointCivilStatus;
				let response = await DataConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getRol() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = DataConfig.endpointGetRol;
				let response = await DataConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getGenders() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = DataConfig.endpointGenders;
				let response = await DataConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getNationalities() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = DataConfig.endpointNationalities;
				let response = await DataConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
	static getRelationship() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = DataConfig.endpointRelationship;
				let response = await DataConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
	static getAffiliateStatusCantNow() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = DataConfig.endpointAffiliateStatusCantNow;
				let response = await DataConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/Data/DataService.js